/* src/app/stocking/product-types/product-types.component.css */
.example-card {
  margin: 16px;
  max-width: 700px;
}
.pt-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px 4px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: 600;
  color: #888;
}
.pt-header-handle {
  width: 24px;
  flex: 0 0 24px;
}
.pt-header-field {
  flex: 1 1 auto;
  min-width: 0;
}
.pt-header-action {
  width: 40px;
  flex: 0 0 40px;
}
.pt-list {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  min-height: 40px;
  margin-top: 16px;
  margin-bottom: 12px;
}
.pt-header + .pt-list {
  margin-top: 0;
}
.pt-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 8px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}
.pt-row:last-child {
  border-bottom: none;
}
.pt-handle {
  cursor: grab;
  color: #bbb;
  flex: 0 0 24px;
}
.pt-input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  padding: 8px 4px;
  border-bottom: 1px solid transparent;
}
.pt-input:focus {
  border-bottom: 1px solid #888;
}
.pt-input::placeholder {
  color: #bbb;
}
.pt-empty {
  padding: 20px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.row-error {
  color: #c62828;
  margin-bottom: 8px;
  font-size: 0.9em;
}
.cdk-drag-preview {
  box-shadow: 0 4px 12px rgba(0, 0, 0, .18);
  border-radius: 6px;
  background: #fff;
}
.cdk-drag-placeholder {
  opacity: .35;
}
.cdk-drop-list-dragging .pt-row:not(.cdk-drag-placeholder) {
  transition: transform 200ms cubic-bezier(0, 0, .2, 1);
}
/*# sourceMappingURL=product-types.component.css.map */
